// InstaWorthy Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { config } from './Constants';

// Firebase configuration
const firebaseConfig = {
    apiKey: config.firebaseApiKey,
    authDomain: config.firebaseAuthDomain,
    projectId: config.firebaseProjectId,
    storageBucket: config.firebaseStorageBucket,
    messagingSenderId: config.firebaseMessagingSenderId,
    appId: config.firebaseAppId,
    measurementId: config.firebaseMeasurementId
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Auth functions
export const signUpWithEmailAndPassword = async (email, password, name, gender = '') => {
    try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        
        // Create user document in Firestore
        await setDoc(doc(db, 'users', user.uid), {
            ...config.emptyUserObject,
            email: user.email,
            name: name,
            demographics: {
                ...config.emptyUserObject.demographics,
                gender: gender || null
            },
            createdAt: new Date(),
            lastLoginAt: new Date()
        });
        
        return user;
    } catch (error) {
        throw error;
    }
};

export const signInWithEmailAndPasswordAuth = async (email, password) => {
    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        
        // Update last login
        await setDoc(doc(db, 'users', user.uid), {
            lastLoginAt: new Date()
        }, { merge: true });
        
        return user;
    } catch (error) {
        throw error;
    }
};

export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        const user = result.user;
        
        // Check if user document exists
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        
        if (!userDoc.exists()) {
            // Create new user document
            await setDoc(doc(db, 'users', user.uid), {
                ...config.emptyUserObject,
                email: user.email,
                name: user.displayName || '',
                createdAt: new Date(),
                lastLoginAt: new Date()
            });
        } else {
            // Update last login
            await setDoc(doc(db, 'users', user.uid), {
                lastLoginAt: new Date()
            }, { merge: true });
        }
        
        return user;
    } catch (error) {
        throw error;
    }
};

export const signOutUser = async () => {
    try {
        await signOut(auth);
    } catch (error) {
        throw error;
    }
};

export default app;